<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii"></a>
<p class="fm1t"><em class="italic">She’s only a bird in a gilded cage,</em></p>
<p class="fm1"><em class="italic">A beautiful sight to see.</em></p>
<p class="fm1"><em class="italic">You may think she’s happy and free from care.</em></p>
<p class="fm1"><em class="italic">She’s not, though she seems to be…</em></p>
<p class="fm1at">FROM “BIRD IN A GILDED CAGE,”</p>
<p class="fm1a">BY ARTHUR J. LAMB AND HARRY VON TILZER, 1900</p>
<a id="page_viii"></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Fm01.vue?09f76878